import {Directive} from '@angular/core';

@Directive({
    selector: '[cbTableBody]',
    standalone: false
})
export class CbTableBodyDirective {
}
